import React from 'react';
import classNames from 'classnames';

import { getAvailablePaymentMethods } from '../../util/paymentMethods';
import css from './PaymentMethodsRow.module.css';

/* Klarna is not offered (P25009-461), so it is not shown either — the
 * methods come from the same list checkout is built on. */
const LABELS = {
  card: 'Kort',
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
  mobilepay: 'MobilePay',
};

/**
 * "Betala med  Kort · Apple Pay · Google Pay" — the payment methods visible
 * before the buyer commits (P25009-486 BR-4 listing page, BR-10 checkout).
 *
 * @param {Object} props
 * @param {string} [props.currency] defaults to SEK
 * @param {string} [props.country] defaults to SE
 * @param {boolean} [props.showLabel] the "Betala med" lead-in
 */
const PaymentMethodsRow = ({ className, currency = 'SEK', country = 'SE', showLabel = true }) => {
  const methods = getAvailablePaymentMethods(currency, country).filter(m => LABELS[m]);
  if (methods.length === 0) return null;
  return (
    <div className={classNames(css.root, className)} aria-label="Betalsätt">
      {showLabel ? <span className={css.label}>Betala med</span> : null}
      {methods.map(method => (
        <span key={method} className={css.method}>
          {LABELS[method]}
        </span>
      ))}
    </div>
  );
};

export default PaymentMethodsRow;
